import { Observable } from 'rxjs';
import { environment } from './../../../../environments/environment';
import { ListaMarcas } from './../../../_entities/dispositivos/AgregarDispositivoVM';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MarcaDispositivoService {

  constructor(private http: HttpClient) { }

  obtenerMarcas() {
    return this.http.get<ListaMarcas[]>(`${environment.API_SECURITY}/api/marcasEquipo`);
  }

  obtenerMarca(idMarca): Observable<ListaMarcas>{
    return this.http.get<ListaMarcas>(`${environment.API_SECURITY}/api/marcasEquipo/${idMarca}`);
  }

  agregarMarca(form):Observable<ListaMarcas>{
    return this.http.post<ListaMarcas>(`${environment.API_SECURITY}/api/marcasEquipo`,form);
  }

  actualizarMarca(form):Observable<ListaMarcas>{
    return this.http.put<ListaMarcas>(`${environment.API_SECURITY}/api/marcasEquipo`,form);
  }


  eliminarMarca(idMarca): Observable<any>{
    return this.http.delete(`${environment.API_SECURITY}/api/marcasEquipo/${idMarca}`);
  }
}
